module.exports = __webpack_public_path__ + "static/media/p_50_1.a82380dc.png";